import React from "react";
import { FaFacebookF, FaInstagram, FaPinterest } from "react-icons/fa";

const Footer = () => {
    return (
        <>
            <footer>
                <div className="main-footer">
                    <div className="container">
                        <div className="inner-footer">
                            <div className="iteam">
                                <div className="itm1-inner">
                                    <div className="logo">
                                        <img src="../assets/img/logo-light-1.png" alt="logo" />
                                    </div>
                                    <div className="text">
                                        <p>Dan Photography Agency habitant morbi tristique senectus et netus et malesuada fames shootin the lacinia the adama sor drana diam.</p>
                                    </div>
                                </div>
                                <div className="itm2-inner">
                                    <p>
                                        <b>Get in touch</b>
                                        E: info@danhalsman.com
                                        <br />
                                        P: +1 650-444-0000
                                        <br />
                                        A: 525 West Ave, CT 06850 — Norwalk
                                    </p>
                                </div>
                                <div className="itm3-inner">
                                    <div className="follow-block">
                                        <b>Follow Us</b>
                                        <p>You can follow us on our social media accounts for up-to-date photos.</p>
                                        <ul className="icone-block">
                                            <li className="same-icone">
                                                <a href="https://www.facebook.com/" target="_blank" rel="noreferrer"><FaFacebookF /></a>
                                            </li>
                                            <li className="same-icone">
                                                <a href="https://www.instagram.com/" target="_blank" rel="noreferrer"><FaInstagram /></a>
                                            </li>
                                            <li className="same-icone">
                                                <a href="https://pinterest.com/" target="_blank" rel="noreferrer"><FaPinterest /></a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="sub-footer">
                    <div className="container">
                        <div className="inner-footer">
                            <div className="itm2">
                                <p>© 2023 Dan Halsman. All right reserved.</p>
                            </div>
                            <div className="item2">
                                <p>
                                    <a href="#">Terms of use</a>
                                    <span>|</span>
                                    <a href="#">Privacy Policy</a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    );
}
export default Footer;